import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { EcmDispatcherModule } from '@ecm/dispatcher';
import { ContextService } from '@ecm/portfolio';
import { RouterService } from '@ecm/router';

@Injectable({
    providedIn: 'root',
})
export class VisitorsGuard {
    private static readonly CLASS_NAME: string = 'VisitorGuard';

    private readonly routerService = inject(RouterService);
    private readonly contextService = inject(ContextService);

    /**
     * redirects to dashboard for identified customers
     * If user is authenticated, redirects to `/accueil` route
     * @returns {Observable<boolean> | boolean}
     */
    public canActivate(): Observable<boolean> {
        return this.contextService.isAuthenticated().pipe(
            map((isAuthenticated: boolean) => {
                if (isAuthenticated) {
                    EcmDispatcherModule.sendConsoleInfo(VisitorsGuard.CLASS_NAME, 'User is authenticated');
                    this.routerService.navigate(['accueil']);
                }
                return !isAuthenticated;
            }),
        );
    }
}
